import {  GET_SMTP_DETAILS } from "../../actions/type";

const initialSmtpDetails = {
    smtpDetails: null,
    isLoading: true,

  };

  export const reducer = (state = initialSmtpDetails, action) => {
    switch (action.type) {
      case GET_SMTP_DETAILS: {
        const smtpDetails = action.payload;
        return {
          ...state,
          smtpDetails: smtpDetails,
          isLoading: false,

        };
      }
      default:
        return state;
    }
  };